import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Button,
  Alert,
  InputGroup,
  Col,
  Row,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import {
  getActiveMemberTypeList,
  getCountryActiveListApi,
  memberLogIn_NewApi,
  sendLoginRamNamOtpApi,
} from "../ramnambook-registration/RamNamBookCRUD";
import { CountryData } from "../other-drop-downs/OtherDropDowns";
import { FaEye, FaEyeSlash } from "react-icons/fa";

// ✅ Validation schema
const schema = Yup.object({
  mobileNumber: Yup.string()
    .required("Mobile number is required")
    .matches(/^[0-9]{9,13}$/, "Enter valid mobile number"),

  password: Yup.string()
    .min(4, "Password must be at least 4 characters")
    .max(12, "Password must not exceed 12 characters")
    .required("Password is required"),
  // countryID: Yup.number().required("Please select a country"),
  // memberTypeID: Yup.number().required("Please select a type"),
});

const LoginPage = ({ show, onHide }) => {
  // const LoginPage = (props) => {
  const navigate = useNavigate();
  const [countries, setCountries] = useState([]);
  const [memberTypes, setMemberTypes] = useState([]);
  const [countryID, setCountryID] = useState(22);
  const [countryDialCode, setCountryDialCode] = useState("+91");
  const [mobileLength, setMobileLength] = useState(10);
  const [memberTypeID, setMemberTypeID] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showForgetPassword, setShowForgetPassword] = useState(false);
  const ADMIN_WEB = process.env.REACT_APP_WEB_URL;
  const [showDialDropdown, setShowDialDropdown] = useState(false);
  const isLoggedIn = !!localStorage.getItem("customer");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/member/dashboard", { replace: true });
    }
  }, []);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    // mode: "onTouched",
  });
  console.log("countryDialCode", countryDialCode);

  // ✅ Load country list
  // useEffect(() => {
  //   getActiveMemberTypeDDLData();
  //   getCountryActiveDataListApi();
  // }, []);

  // const getCountryActiveDataListApi = async () => {
  //   try {
  //     const res = await getCountryActiveListApi();
  //     if (res.data.isSuccess) {
  //       setCountries(res.data.responseObject);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // function getActiveMemberTypeDDLData() {
  //   getActiveMemberTypeList()
  //     .then((response) => {
  //       let responseData = response.data.responseObject;
  //       if (response.data.isSuccess == true) {
  //         setMemberTypes(responseData);
  //       } else {
  //         toast.error(`${response.data.message}`);
  //         setMemberTypes([]);
  //       }
  //     })
  //     .catch((error) => {
  //       toast.error(`${error}`);
  //       setMemberTypes([]);
  //     });
  // }

  // ✅ Submit handler (WORKING)
  const onSubmit = async ({ mobileNumber, password }) => {
    try {
      const response = await memberLogIn_NewApi(
        countryID,
        mobileNumber,
        memberTypeID,
        password,
        // countryDialCode,
      );

      if (response.data.isSuccess) {
        toast.success(response.data.message);
        const customerData = {
          ramNamBookMemberID: response.data.memberID,
          countryID: response.data.countryID,
          memberName: response.data.memberName, // 👈 customer name stored
          mobileNumber: response.data.mobileNumber,
          addressAndText: response.data.addressAndText,
          villageCityName: response.data.villageCityName,
          pincode: response.data.pincode,
          countryName: response.data.countryName,
          memberTypeID: response.data.memberTypeID,
          memberType: response.data.memberType,
        };
        localStorage.setItem("customer", JSON.stringify(customerData));
        sessionStorage.setItem("otpVerifiedAt", Date.now().toString());
        navigate("/member/dashboard");
        // navigate("/verify-otp", {
        //   state: {
        //     otpdata: response.data.data,
        //     mode: "login",
        //     mobileNumber,
        //     countryID,
        //     countryDialCode,
        //     memberTypeID,
        //   },
        // });
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Failed to send OTP. Please try again.");
    }
  };

  const handleOpenMemberSite = () => {
    window.open(`${ADMIN_WEB}/book-registration`, "_bank");
    // window.open("http://localhost:3011", "_blank");
  };
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="md"
      backdrop="static"
      keyboard={false}
    >
      {/* Header with Logo */}
      <Modal.Header
        className="pb-0"
        style={{ display: "flex", justifyContent: "center", border: "none" }}
      >
        <Modal.Title>
          <img
            src={"/assets/logo/barejadham1.png"}
            alt="Logo"
            height="80"
            width="80"
            className="mx-auto"
          />
          {/* શ્રી રામવાળી મેલડી માઁ [બારેજા ધામ] */}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-center align-items-center">
        <div
          // className="bg-white shadow rounded-4 p-4"
          className="bg-white"
          style={{ width: "100%", maxWidth: "420px" }}
        >
          <h6 className="text-center mb-2 fw-bold text-danger">Login</h6>

          {errors.root && (
            <Alert variant="danger" className="py-2 text-center">
              {errors.root.message}
            </Alert>
          )}

          <Form onSubmit={handleSubmit(onSubmit)} noValidate className="px-2">
            {/* Mobile Number */}
            <Form.Group className="mb-3">
              <Form.Label className="text-dark">
                Mobile Number <span className="text-danger">*</span>
              </Form.Label>

              <InputGroup>
                {/* Country Dial */}
                <div
                  style={{
                    position: "relative",
                    width: "110px",
                  }}
                >
                  <div
                    className="form-select d-flex align-items-center gap-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowDialDropdown(!showDialDropdown)}
                  >
                    {(() => {
                      const selected = CountryData.find(
                        (c) => c.countryID === Number(countryID),
                      );
                      return selected ? (
                        <>
                          <img
                            src={selected.flagPath}
                            alt={selected.countryName}
                            width="20"
                            height="15"
                            style={{ objectFit: "cover" }}
                          />
                          <span>{selected.countryDialNumber}</span>
                        </>
                      ) : (
                        "Select"
                      );
                    })()}
                  </div>

                  {showDialDropdown && (
                    <div
                      className="border bg-white shadow rounded-3"
                      style={{
                        position: "absolute",
                        width: "100%",
                        maxHeight: "220px",
                        overflowY: "auto",
                        zIndex: 1000,
                      }}
                    >
                      {CountryData.map((c) => (
                        <div
                          key={c.countryID}
                          className="d-flex align-items-center gap-2 p-2 hover-bg"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setCountryID(c.countryID);
                            setCountryDialCode(c.countryDialNumber);
                            setMobileLength(c.mobileLength);

                            setValue("mobileNumber", ""); // Clear mobile number on country change
                            setShowDialDropdown(false);
                            clearErrors("root");
                          }}
                        >
                          <img
                            src={c.flagPath}
                            alt={c.countryName}
                            width="20"
                            height="15"
                          />
                          <span>{c.countryDialNumber}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Mobile Input */}
                <Form.Control
                  type="text"
                  placeholder={`Enter ${mobileLength} digit mobile number`}
                  maxLength={mobileLength}
                  inputMode="numeric"
                  {...register("mobileNumber", {
                    onChange: (e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setValue("mobileNumber", value);
                      clearErrors("root");
                    },
                  })}
                  isInvalid={!!errors.mobileNumber}
                />
              </InputGroup>

              <Form.Control.Feedback type="invalid">
                {errors.mobileNumber?.message}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Password */}
            <Form.Group className="mb-4">
              <Form.Label className="text-dark d-flex justify-content-between">
                <span>
                  Password <span className="text-danger">*</span>
                </span>

                <Link
                  to="/forgot-password"
                  className="link-primary fs-6 fw-bold text-decoration-none"
                >
                  Forgot Password?
                </Link>
              </Form.Label>

              <InputGroup>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  {...register("password")}
                  isInvalid={!!errors.password}
                  placeholder="Enter your password"
                  className="shadow-sm"
                  style={{
                    height: "45px",
                    borderRadius: "10px 0 0 10px",
                  }}
                />

                <Button
                  variant="outline-secondary"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    borderRadius: "0 10px 10px 0",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>

                <Form.Control.Feedback type="invalid">
                  {errors.password?.message}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>

            {/* Submit Button */}
            <Button
              type="submit"
              className="w-100 rounded-3 text-white fw-bold"
              style={{
                backgroundColor: "#FF4F00",
                border: "none",
                padding: "10px",
              }}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Logging in..." : "Login"}
            </Button>
          </Form>

          {/* Register Link */}
          <p className="text-center mt-3 mb-0">
            Don’t have an account?{" "}
            <span
              className="text-primary text-primary fw-bolder"
              style={{ cursor: "pointer" }}
              onClick={handleOpenMemberSite}
            >
              Register
            </span>
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LoginPage;
